import { mergeObjectTypes } from '../cacheHelpers';

const ConsolidatedLooseCargoItem = {
  merge: mergeObjectTypes
};

export default ConsolidatedLooseCargoItem;
